/**
 * Javascript for register view of ige_shop.
 * Product Owner: Raphael Wälterlin <raphael.waelterlin@cabag.ch>
 * Author: Markus Gehrig <markus.gehrig@cabag.ch>
 * Date: 15. Apr 2019
 * 
 * Customer: Prospecia Rara
 * Company: cab services ag
 */

/**
 * Load external JavaScript Libaries
 */

var $           = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks    = require('../../../../../../../webpack/node_modules/nunjucks');
var basket      = require("./basket.js");

/**
 * Global vars
 */
var container = ".psr-shop-form";

$( document ).ready(function() {
    if ( $( container ).length ) {
        setBasket();
    }
}); 

function setBasket() {
    nunjucks.configure('/template/dist/views-shop', {autoescape: true});

    var items = basket.getBasket();
    var showVat = window.showVat;
    var view = nunjucks.render('register.twig', {currency: currency, items: items, showVat: showVat});
    var regex = /<br\s*[\/]?>/gi;
    view = view.replace(regex, "\n").trim();

    var hiddenField = $(container + ' .form-group input[type="text"]')[0];
    $(hiddenField).addClass('d-none');
    $(hiddenField).attr('value', view);
}
